import getConfig from "next/config";
import { Field } from "react-final-form";

import InputCheckbox from "@components/Form/Checkbox";
import { composeFormValidators, isRequired } from "@lib/validations";

const {
  publicRuntimeConfig: {
    settings: { baseUrl },
  },
} = getConfig();

const GdprConsentSection = () => (
  <div className="space-y-[20px]">
    <div className="bg-white p-[16px] space-y-[16px]">
      <Field
        name="policyConsultancy"
        component={InputCheckbox}
        type="checkbox"
        label="Declar ca aleg sa renunt la acordarea consultantei, in conformitate cu prevederile legale aplicabile comercializarii electronice a produselor de asigurare."
        required
        validate={composeFormValidators(isRequired())}
        className="text-[14px] font-normal cursor-pointer max-w-fit"
      />

      <Field
        name="policyTermsAndPrivacy"
        component={InputCheckbox}
        type="checkbox"
        label={
          <span>
            Accept{" "}
            <a
              href={`${baseUrl}/rca-termeni-conditii/pag/`}
              className="font-medium text-red-brand hover:text-bleu-hover underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Termenii și Conditiile,
            </a>{" "}
            <a
              href={`${baseUrl}/rca-protectia-datelor-caracter-personal/pag/`}
              className="font-medium text-red-brand hover:text-bleu-hover underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Politica de confidentialitate si consimtamantul GDPR
            </a>{" "}
            si sunt de acord cu prelucrarea datelor personale in scopul
            procesarii acestei solicitari.
          </span>
        }
        required
        validate={composeFormValidators(isRequired())}
        className="text-[14px] font-normal cursor-pointer max-w-fit"
      />
    </div>
  </div>
);

export default GdprConsentSection;
